module.exports = __webpack_public_path__ + "img/edoc.29adcb97.png";